import { transferAccountOwnership } from '@hotjar/webapp/domains/settings/api';
import type { TransferAccountOwnershipResponse } from '@hotjar/webapp/domains/settings/types';

export const mutateAccountOwnership = async ({
  accountId,
  newOwnerId,
  password,
}: {
  accountId: number;
  newOwnerId: number;
  password: string;
}): Promise<TransferAccountOwnershipResponse> => {
  const response = await transferAccountOwnership(accountId, newOwnerId, password);
  return response.data;
};
